<template lang="pug">
MyGamesHeader(
  :userLinks="user_links",
  :headerBGColor="headerBGColor",
  :headerTextColor="headerTextColor",
  :promoName="promo_name",
  :hideNavigation="true",
  :hideLogo="true")
</template>

<script>
import env from "@godweb/frontend-base/src/libs/tools/Environment";
import MyGamesHeader from "@godweb/frontend-base/src/components/mygamesheader/MyGamesHeader";

export default {
  name: "MyGamesHeaderWrapper",

  components: {
    MyGamesHeader,
  },

  props: {
    headerBGColor: {
      type: String,
      default: "",
      required: false,
    },
    headerTextColor: {
      type: String,
      default: "",
      required: false,
    },
  },

  data() {
    return {
      promo_name: process.env.VUE_APP_PROMO,
      user_links: [
        {
          url: "https://account.my.games/profile/userinfo/",
          title: this.$t("mygames.user_menu.my_account"),
          blank: true,
        },
        {
          url: `/${env.getLang()}/inventory`,
          title: this.$t("mygames.user_menu.storage"),
        },
        {
          url: `/${env.getLang()}/promocode`,
          title: this.$t("mygames.user_menu.promocode"),
        },
        {
          title: this.$t("mygames.user_menu.logout"),
          callback: this.logout,
        },
      ],
    };
  },

  methods: {
    logout() {
      return this.$authService.logout();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../style/mygamesheader.scss";
</style>
